import * as React from "react";
const SvgFiRrReplyAll = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-reply-all_svg__a)">
      <path d="M19 8H8.554l6.223-6.224A.999.999 0 1 0 13.363.362L6.172 7.554a2 2 0 0 0 0 2.828l7.19 7.19a.997.997 0 0 0 1.415 0 1 1 0 0 0 0-1.414L8.617 10H19c1.654 0 3 1.346 3 3v10a1 1 0 1 0 2 0V13c0-2.757-2.243-5-5-5" />
      <path d="M2.586 10.312c-.78-.78-.78-2.049 0-2.829l5.776-5.776A.999.999 0 1 0 6.948.293L1.172 6.07a4.004 4.004 0 0 0 0 5.657l5.776 5.776a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414z" />
    </g>
    <defs>
      <clipPath id="fi-rr-reply-all_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrReplyAll;
